import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import Dashboard from '../views/Dashboard/Dashboard';
import DataDetail from '../views/Data/Detail';
import DataMain from '../views/Data/Main';
import DataSummary from '../views/Data/Summary';
import DataSiteSelector from '../views/Data/SiteSelector';
import Login from '../views/Login';
import ForgotPassword from '../views/ForgotPassword';
import ResetPassword from '../views/ResetPassword';
import Error from '../views/Error';
import Signup from '../views/Signup';
import Main from '../views/Main';
import AnalyzeMain from '../views/Analysis/AnalyzeMain';
import AnalyzeGeneral from '../views/Analysis/Tabs/AnalyzeGeneral';
import AnalyzeScope1 from '../views/Analysis/Tabs/Scope1';
import AnalyzeScope2 from '../views/Analysis/Tabs/Scope2';
import AnalyzeScope3 from '../views/Analysis/Tabs/Scope3';
import Compare from '../views/Analysis/Tabs/Compare';
import GoalSummary from '../views/Goal/Summary';
import GoalDetail from '../views/Goal/Detail';
import FilesSummary from '../views/Doc/Files/Summary';
import FormSummary from '../views/Doc/Forms/FormSummary';
import FormCreate from '../views/Doc/Forms/FormCreate';
import FormDetail from '../views/Doc/Forms/FormDetail';
import SiteForms from '../views/Doc/Forms/SiteForms';
import FilesDetail from '../views/Doc/Files/Detail';
import DocMain from '../views/Doc/DocMain';
import AuditMain from '../views/Audit/AuditMain';
import Audit from '../views/Audit/Audits/Audit';
import Summary from '../views/Audit/AuditRecords/Summary';
import Detail from '../views/Audit/AuditRecords/Detail';
import TicketDetail from '../views/Audit/Audits/TicketDetail';
import TicketList from '../views/Audit/Audits/TicketList';
import Admin from '../views/Setting/Admin';
import Master from '../views/Setting/Master';
import General from '../views/Setting/General';
import Site from '../views/Setting/Site';
import SiteEdit from '../views/Setting/SiteEdit';
import SiteCreate from '../views/Setting/SiteCreate';
import Permissions from '../views/Setting/Permissions';
import PermissionEdit from '../views/Setting/PermissionEdit';
import Users from '../views/Setting/Users';
import UserProfile from '../views/Setting/UserProfile';
import Sources from '../views/Setting/Sources';
import Tags from '../views/Setting/Tags';
import EmissionLibrary from '../views/Setting/EmissionLibrary';
import Locations from '../views/Setting/Locations';
import AdminGoal from '../views/Setting/AdminGoal';
import EmissionTable from '../views/Setting/EmissionTable';
import EmissionDetail from '../views/Setting/EmissionDetail';
import UnitPrice from '../views/Setting/UnitPrice';
import UnitPriceDetail from '../views/Setting/UnitPriceDetail';
import LoadDataViaExcel from '../views/Setting/LoadDataViaExcel';
import Register from '../views/Register/Register';
import Library from '../views/Library/Library';
import MobileDetect from 'mobile-detect';

Vue.use(Router);

let md = new MobileDetect(window.navigator.userAgent);
let isMobile = false;
if (md.isPhoneSized()) {
    isMobile = true;
}

store.state.isMobile = isMobile;
store.state.isTablet = md.tablet();

let routes = [
    {name: 'error', path: '*', component: Error},
    {
        name: 'main',
        path: '/',
        component: Main,
        children: [
            {
                name: 'data-sites',
                path: '/data',
                component: DataSiteSelector
            },
            {
                name: 'data-main',
                path: '/data/:site_id/types',
                component: DataMain,
                children: [
                    {
                        name: 'site-data-types',
                        path: '/data/:site_id/types',
                        component: DataSummary
                    },
                    {
                        name: 'data-detail',
                        path: ':type_id',
                        component: DataDetail
                    }
                ]
            },
            {
                name: 'analysis',
                path: '/analysis',
                component: AnalyzeMain,
                children: [
                    {
                        name: 'general-analysis',
                        path: 'general',
                        component: AnalyzeGeneral
                    },
                    {
                        name: 'scope-1',
                        path: 'scope1',
                        component: AnalyzeScope1
                    },
                    {
                        name: 'scope-2',
                        path: 'scope2',
                        component: AnalyzeScope2
                    },
                    {
                        name: 'scope-3',
                        path: 'scope3',
                        component: AnalyzeScope3
                    },
                    {
                        name: 'compare',
                        path: 'Compare',
                        component: Compare
                    }
                ]
            },
            {
                name: 'goal',
                path: '/goals',
                component: GoalSummary
            },
            {
                name: 'goal-detail',
                path: '/goals/:site_id',
                component: GoalDetail
            },
            {
                name: 'doc',
                path: '/docs',
                component: DocMain,
                children: [
                    {
                        name: 'site-files',
                        path: ':site_id/files',
                        component: FilesDetail
                    },
                    {
                        name: 'files',
                        path: 'files',
                        component: FilesSummary
                    },
                    {
                        name: 'forms',
                        path: 'forms',
                        component: FormSummary
                    },
                    {
                        name: 'site-forms',
                        path: ':site_id/forms',
                        component: SiteForms
                    },
                    {
                        name: 'form-detail',
                        path: ':site_id/forms/:form_id',
                        component: FormDetail
                    },
                    {
                        name: 'form-create',
                        path: ':site_id/forms/create/:form_type',
                        component: FormCreate
                    }
                ]
            },
            {
                name: 'auditMain',
                path: '/audits',
                component: AuditMain,
                children: [
                    {
                        name: 'Summary',
                        path: 'records',
                        component: Summary
                    },
                    {
                        name: 'Detail',
                        path: 'records/:site_id',
                        component: Detail
                    },
                    {
                        name: 'ticket-list',
                        path: 'audits/:site_id',
                        component: TicketList
                    },
                    {
                        name: 'audit',
                        path: 'audits',
                        component: Audit
                    }
                ]
            },
            {
                name: 'ticket-detail',
                path: 'audits/:site_id/:ticket_id',
                component: TicketDetail
            },
            {
                name: 'dashboard',
                path: '/dashboard',
                component: Dashboard
            },
            {
                name: 'admin',
                path: '/admin',
                component: Admin,
                children: [
                    {
                        name: 'admin-general',
                        path: 'general',
                        component: General
                    },
                    {
                        name: 'admin-site',
                        path: 'sites',
                        component: Site
                    },
                    {
                        name: 'admin-site-create',
                        path: 'sites/create',
                        component: SiteCreate
                    },
                    {
                        name: 'admin-site-edit',
                        path: 'sites/:site_id',
                        component: SiteEdit
                    },
                    {
                        name: 'permissions',
                        path: 'permissions',
                        component: Permissions
                    },
                    {
                        path: 'permissions/edit/:id',
                        name: 'edit-permissions',
                        component: PermissionEdit
                    },
                    {
                        path: 'permissions/add',
                        name: 'add-permission',
                        component: PermissionEdit
                    },
                    {
                        name: 'users',
                        path: 'users',
                        component: Users
                    },
                    {
                        name: 'sources',
                        path: 'sources',
                        component: Sources
                    },
                    {
                        name: 'admin-goal',
                        path: 'goal',
                        component: AdminGoal
                    },
                    {
                        name: 'admin-emission',
                        path: 'emission',
                        component: EmissionTable
                    },
                    {
                        name: 'admin-emission-detail',
                        path: 'emission/:type_id',
                        component: EmissionDetail
                    },
                    {
                        name: 'admin-unit-price',
                        path: 'unit',
                        component: UnitPrice
                    },
                    {
                        name: 'admin-unit-price-detail',
                        path: 'unit/:type_id',
                        component: UnitPriceDetail
                    },
                    {
                        name: 'load-data-via-excel',
                        path: 'load-data-via-excel',
                        component: LoadDataViaExcel
                    }
                ]
            },
            {
                name: 'master',
                path: '/master',
                component: Master,
                children: [
                    {
                        name: 'tags',
                        path: 'tags',
                        component: Tags
                    },
                    {
                        name: 'locations',
                        path: 'locations',
                        component: Locations
                    },
                    {
                        name: 'emission-library',
                        path: 'emission-library',
                        component: EmissionLibrary
                    }
                ]
            },
            {
                name: 'user-profile',
                path: '/user-profile:user_id',
                component: UserProfile
            },
            {
                name: 'library',
                path: '/library',
                component: Library
            }
        ]
    },
    {name: 'login', path: '/login', component: Login},
    {name: 'signup', path: '/signup', component: Signup},
    {name: 'register', path: '/register', component: Register},
    {name: 'forgot-password', path: '/forgot-password', component: ForgotPassword},
    {name: 'reset-password', path: '/reset-password', component: ResetPassword}
];

let router = new Router({
    routes
});

router.beforeEach((to, from, next) => {
    let token = localStorage.getItem('token');
    // Unauthenticated users can only access the login page.
    if (to.path !== '/login' 
        && to.path !== '/register' 
        && to.path !== '/signup' 
        && to.path !== '/forgot-password' 
        && to.path !== '/reset-password') {
        if (!token) {
            return next('/login');
        } else {
            return fetchInitialData(store)
                .then(() => {
                    store.state.isInitiated = true;
                    return next();
                })
                .catch(() => {
                    return next('/login');
                });
        }
    } else {
        return next();
    }
});

// Fetch initial data and store to use in components
function fetchInitialData(store) {
    return new Promise((resolve, reject) => {
        if (store.state.isInitiated) {
            resolve();
        } else {
            return Promise.all([store.dispatch('init')])
                .then(resolve)
                .catch(reject);
        }
    });
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js